import React from 'react';
import { formatDate } from '../../utils/formatters';
import Badge from '../common/Badge';

export default function VehicleCard({ vehicle, onEdit, onDelete }) {
  const dateOnly = (value) => {
    if (!value) return null;
    const date = new Date(value);
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  };

  const complianceMeta = (value) => {
    const dueDate = dateOnly(value);
    if (!dueDate) return null;
    const today = dateOnly(new Date());
    const in30Days = new Date(today);
    in30Days.setDate(in30Days.getDate() + 30);
    if (dueDate < today) {
      return { label: 'Overdue', variant: 'danger', color: 'var(--danger)' };
    }
    if (dueDate <= in30Days) {
      return { label: 'Due Soon', variant: 'warning', color: 'var(--warning-text)' };
    }
    return { label: 'On Track', variant: 'success', color: 'inherit' };
  };

  return (
    <div className="card" style={{ cursor: 'default' }}>
      <div className="card-header">
        <div>
          <div style={{ fontFamily: 'var(--font-display)', fontSize: '1.125rem', fontWeight: 600 }}>{vehicle.registration_number}</div>
          <div style={{ fontSize: '0.875rem', color: 'var(--gray-500)', marginTop: '0.125rem' }}>{vehicle.make} {vehicle.model} {vehicle.year && `(${vehicle.year})`}</div>
        </div>
        <Badge status={vehicle.status} label={vehicle.status?.replace('_', ' ')} />
      </div>
      <div className="card-body">
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem', fontSize: '0.875rem' }}>
          {[
            { key: 'Route', value: vehicle.route || '—' },
            { key: 'Sacco', value: vehicle.sacco_name || '—' },
            { key: 'Capacity', value: vehicle.capacity ? `${vehicle.capacity} seats` : '—' },
            { key: 'TLB Renewal', value: vehicle.tlb_renewal_due_date ? formatDate(vehicle.tlb_renewal_due_date) : '—', dueDate: vehicle.tlb_renewal_due_date },
            { key: 'NTSA Inspection', value: vehicle.ntsa_inspection_due_date ? formatDate(vehicle.ntsa_inspection_due_date) : '—', dueDate: vehicle.ntsa_inspection_due_date },
            { key: 'Speed Governor', value: vehicle.speed_governor_renewal_due_date ? formatDate(vehicle.speed_governor_renewal_due_date) : '—', dueDate: vehicle.speed_governor_renewal_due_date },
            { key: 'Insurance', value: vehicle.insurance_expiry ? formatDate(vehicle.insurance_expiry) : '—', dueDate: vehicle.insurance_expiry },
          ].map(({ key, value, dueDate }) => {
            const status = complianceMeta(dueDate);
            return (
              <div key={key}>
                <div style={{ color: 'var(--gray-400)', fontSize: '0.75rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '0.15rem' }}>{key}</div>
                <div
                  style={{
                    fontWeight: 500,
                    color: status?.color || 'inherit',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.35rem',
                  }}
                >
                  <span>{value}</span>
                  {status && (status.label === 'Overdue' || status.label === 'Due Soon') && (
                    <Badge label={status.label} variant={status.variant} />
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="card-footer" style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
        <button className="btn btn-secondary btn-sm" onClick={() => onEdit(vehicle)}>Edit</button>
        <button className="btn btn-danger btn-sm" onClick={() => onDelete(vehicle)}>Delete</button>
      </div>
    </div>
  );
}